import type { ColonyTileType } from "models/ColonyTileType";
import type { DecisionStackType } from "models/DecisionStackType";
import type { DecisionType } from "models/DecisionType";
import type { FinalScoreType } from "models/FinalScoreType";
import type { GamePayload } from "models/GamePayload";
import type { GeneralPlayerType } from "models/GeneralPlayerType";
import type { HistoryEventType } from "models/HistoryEventType";
import { buildHistoryEventFromPayload } from "models/HistoryEventType";
import type { MilestoneOrAwardType } from "models/MilestoneOrAwardType";
import type { SelfPlayerType } from "models/SelfPlayerType";
import type { TileType } from "models/TileType";

import { EndgameNote } from "./EndgameNote";
import { ReplayConsent } from "./ReplayConsent";

export type GameType = {
  _id: string;
  refreshCounter: number;
  oceansRemaining: number;
  temperatureSteps: number;
  oxygenSteps: number;
  venusSteps: number;
  phase: string;
  numDiscardedCards: number;
  numCardsInDeck: number;
  numDiscardedCorps: number;
  numCorpsInDeck: number;
  venusActive: boolean;
  solarActive: boolean;
  coloniesActive: boolean;
  decisionStack: DecisionStackType[];
  tiles: TileType[];
  startingPlayer: number;
  generation: number;
  history: HistoryEventType[];
  milestones: MilestoneOrAwardType[];
  awards: MilestoneOrAwardType[];
  finalScores?: FinalScoreType[];
  currentPlayerDecision: string;
  currentPlayerDecisionData?: DecisionType;
  player: SelfPlayerType;
  allPlayers: GeneralPlayerType[];
  colonyTiles: ColonyTileType[];
  endgameNotes: EndgameNote[];
  replayConsents: ReplayConsent[];
  replay?: {
    isReplay: boolean;
    sourceGameId?: string;
  };
};

export const buildGameTypeFromGamePayload = ({ history, ...rest }: GamePayload): GameType => ({
  ...rest,
  history: history.map(buildHistoryEventFromPayload),
});
